import { createContext, useContext } from 'react';

import type { Skill_CareerRole } from '__generated__/graphql-types-do-not-use';

export type InferredRoleContextType = {
  inferredRole?: Pick<Skill_CareerRole, 'id' | 'name' | 'slug'>;
  setCareerRole: () => void;
  inferredRoleLoading?: boolean;
  isSettingCareerRole?: boolean;
};

const InferredRoleContext = createContext<InferredRoleContextType>({
  inferredRole: undefined,
  setCareerRole: () => {},
  inferredRoleLoading: false,
  isSettingCareerRole: false,
});

/**
 * @description hook to access the user's inferred role and setting it to the learner profile
 */
export const useInferredRole = () => useContext(InferredRoleContext);

export default InferredRoleContext;
